var React = require('react');

function Error (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M11.5 20a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm1.174-13.075H10.42l.476 5.977h1.358l.42-5.977zm-2.226 8.195c0 .616.49 1.106 1.092 1.106.616 0 1.12-.49 1.12-1.106 0-.616-.504-1.12-1.12-1.12-.602 0-1.092.504-1.092 1.12z","id":"error-a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"error-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#error-a"})),React.createElement("g",{"mask":"url(#error-b)","fill":"currentColor","key":1},React.createElement("path",{"d":"M0 0h23v23H0z"}))])]);
}

Error.defaultProps = {"viewBox":"0 0 23 23","width":"23","height":"23"};

module.exports = Error;

Error.default = Error;
